/* ============================================================
   CUTE CALCULUS — SUB PLANS
   ------------------------------------------------------------
   This file holds the substitute teacher packets, and nothing
   else. It is kept SEPARATE from cc-catalog.js on purpose:
   the catalog is the student side of the site and you edit it
   all the time, and every unit of six courses would bury it.

   HOW IT WORKS
     Every unit below can sell three things:
       day   one full no prep day on that unit
       week  five different no prep days on that unit
       full  the whole unit, fifteen days, for the units that
             actually run three or four weeks

   ⭐ YOU DO NOT NEED 111 SHOPIFY PRODUCTS. Pick whichever of
   these three suits you, per course, and you can change your
   mind later without touching anything but this file.

     1. ONE PRODUCT PER COURSE, the easy way.
        Make ONE product, "Algebra 1 sub plans", with TWO options:
        Unit (Unit 1 to Unit 10) and Length (One day, Five days,
        Full unit). Shopify builds the grid for you. Put its
        handle on the course line as product:'algebra-1-sub-plans',
        then write a single + on every unit you have finished.

        The WHOLE COURSE bundle is its own separate product, not
        a variant, because it has no unit to sit under. Put that
        product's handle on the course line as bundle:'...'.

     2. ONE PRODUCT PER COURSE, straight to the right variant.
        Same product as above, but paste the VARIANT ID number
        into day or week instead of the +. The button then opens
        the product with that unit already picked, so the buyer
        does not have to find it in a dropdown.

     3. TWO PRODUCTS PER COURSE.
        One product holding the one day and five day variants,
        a second holding the 15 day full unit variants. Put the
        first handle in product and the second in fullProduct,
        then write + on every unit you have finished.

     4. ONE PRODUCT PER PACKET.
        Paste the product HANDLE into day or week or full. Best
        for the buyer, most work for you.

   WHERE THE HANDLE IS
     Shopify admin, Products, open the product, look at the
     address bar or the SEO box at the bottom. The handle is the
     last piece of /products/<this-part>. Paste that piece.

   WHERE THE VARIANT ID IS
     On the product page in admin, click the variant. The address
     bar ends in /variants/<a long number>. That number.

   Left blank, a unit shows as "coming soon", which is safe.
   Nothing ever 404s, so you can publish one unit at a time and
   the page fills itself in as you go.

   PRICES are set ONCE at the top, not per unit, so changing
   your day price is one edit and not fifty five.
   ============================================================ */

window.CC_SUBS = {

  /* ---------- prices, set once ---------- */
  /* Leave a price as '' and no price shows, which is safe.
     Write it the way you want it read, like '$6'. */
  price: {
    day:       '$3.99',         /* one full day, any unit */
    week:      '$9.99',         /* five days on one unit */
    unit:      '$14.99',        /* the whole unit, 15 days */
    course:    '$49.99',        /* every unit of one course */
    emergency: ''               /* the grab and go packet, blank means free */
  },

  /* ---------- the whole library, every course ---------- */
  /* Optional. Leave the handle blank and this does not appear at all,
     so it costs you nothing until you decide you want it. */
  everything: {
    title:  'Every course, every unit',
    blurb:  'All six courses, every unit, all three lengths, plus the emergency packet. For a department, or for a teacher who covers more than one course.',
    handle: '',                 /* <- your product handle */
    price:  ''
  },

  /* ---------- the grab and go packet ---------- */
  /* One file that works in ANY middle or high school math room,
     on a day nobody planned for. Sold on its own. */
  emergency: {
    title:  'Emergency Sub Day, any math class',
    blurb:  'No prep, no context, no textbook. Hand it to a sub who has never taught math and the room still works.',
    inside: 'Instructions written for the sub, a rules page so students need no teacher, a warm up, five worked pages, a puzzle page for early finishers, a tear off exit ticket, a one minute sub report form, and a full answer key.',
    grade:  '6th to 12th',
    pages:  15,
    handle: 'emergency-substitute-teacher-pack-grades-6-12'
  },

  /* ---------- what every packet contains ---------- */
  /* Shown on the hub page. Edit the words, not the structure. */
  inside: [
    ['Sub instructions',  'One page, written for someone who does not teach math. What to say, what to hand out, how long each piece takes.'],
    ['Warm up',           'Eight quick problems from the unit before, so the room settles while the sub takes attendance.'],
    ['The teach page',    'The rule, worked out, in the words a student can read alone. No lecture required.'],
    ['Practice',          'Two pages that climb, so a fast student is not idle and a slow one is not lost.'],
    ['Exit ticket',       'Four problems on a tear off strip. Proof the day was not wasted.'],
    ['Answer key',        'Every answer, with the step. So the sub can check work, and so you can see what happened.']
  ],

  /* ---------- how it works, the three steps ---------- */
  steps: [
    'Find your course, then the unit you are in.',
    'Buy one day, five days, or the whole unit at fifteen days.',
    'Print it, or email the PDF to the front office. That is the whole job.'
  ],

  /* ============================================================
     THE COURSES
     Add a unit by copying a line. Remove one by deleting it.
     n     the unit number as your scope and sequence has it
     name  what the unit is called
     on    the topics inside it, so a teacher can find their week
     day   the one day packet:  '+' or a variant id or a handle
     week  the five day bundle: '+' or a variant id or a handle
     full  the whole unit, 15 days: same three ways

     ON THE COURSE LINE
     product      the one product per course handle. A '+' on a
                  unit's day or week points at this one.
     fullProduct  a SECOND product holding just the 15 day full
                  unit packets, if you keep them separate. A '+'
                  on a unit's full points here instead. Leave it
                  blank and full falls back to product.
     bundle       the whole course in one purchase. Same three
                  ways: '+', a variant id, or its own handle.
                  Blank and no bundle is offered.
     bundlePrice  only if this course costs a different amount
                  from the price.course set at the top
     ============================================================ */
  courses: [

    { key:'prealgebra', name:'Pre-Algebra', sym:'%', color:'butter', grade:'6th to 8th',
      product:'pre-algebra-substitute-teacher-plas',   /* the One day / Five days / FULL UNIT variants */
      fullProduct:'',        /* blank: the full unit is a variant of the product above */
      bundle:'pre-algebra-full-year-substitute-teacher-plans',   /* the whole course in one purchase */
      bundlePrice:'',        /* only if this course costs a different amount from the rest */
      units:[
        { n:1,  name:'Integers and the number line',  on:'opposites, comparing, absolute value, all four operations', day:'+', week:'+', full:'+' },
        { n:2,  name:'Fractions, decimals, percents', on:'converting, operations, comparing, lowest terms',           day:'+', week:'+', full:'+' },
        { n:3,  name:'Exponents and scientific notation', on:'powers, the rules, square roots, very big and very small numbers', day:'+', week:'+', full:'+' },
        { n:4,  name:'Ratios, rates and proportions', on:'unit rate, scale, solving a proportion, similar figures',   day:'+', week:'+', full:'+' },
        { n:5,  name:'Percent applications',          on:'tax, tip, discount, markup, percent change, simple interest', day:'+', week:'+', full:'+' },
        { n:6,  name:'Expressions and properties',    on:'like terms, distributing, evaluating, the number properties', day:'+', week:'+', full:'+' },
        { n:7,  name:'Equations',                     on:'one step, two step, variables both sides, checking a solution', day:'+', week:'+', full:'+' },
        { n:8,  name:'Inequalities',                  on:'solving, the flip rule, graphing on a number line',         day:'+', week:'+', full:'+' },
        { n:9,  name:'Linear relationships',          on:'the coordinate plane, tables, slope, graphing a rule',      day:'+', week:'+', full:'+' },
        { n:10, name:'Geometry, measurement and data', on:'angles, area, surface area, volume, Pythagoras, mean median mode', day:'+', week:'+', full:'+' }
      ] },

    { key:'algebra1', name:'Algebra 1', sym:'x', color:'blush', grade:'8th to 10th',
      product:'',            /* one product for the whole course, if you use one */
      fullProduct:'',        /* a SECOND product just for the 15 day full unit packets, if you split them out */
      bundle:'',             /* the whole course in one purchase: '+', a variant id, or a handle */
      bundlePrice:'',        /* only if this course costs a different amount from the rest */
      units:[
        { n:1,  name:'The language of algebra',       on:'translating, evaluating, order of operations',   day:'', week:'', full:'' },
        { n:2,  name:'Solving equations',             on:'multi step, variables both sides, literal',      day:'', week:'', full:'' },
        { n:3,  name:'Inequalities',                  on:'one and two step, compound, absolute value',     day:'', week:'', full:'' },
        { n:4,  name:'Linear functions and graphing', on:'slope, intercepts, graphing a line',             day:'', week:'', full:'' },
        { n:5,  name:'Writing linear equations',      on:'point slope, from two points, parallel lines',   day:'', week:'', full:'' },
        { n:6,  name:'Systems of equations',          on:'graphing, substitution, elimination',            day:'', week:'', full:'' },
        { n:7,  name:'Exponents',                     on:'the rules, negative exponents, scientific notation', day:'', week:'', full:'' },
        { n:8,  name:'Polynomials and factoring',     on:'adding, FOIL, GCF, trinomials, difference of squares', day:'', week:'', full:'' },
        { n:9,  name:'Quadratic functions',           on:'graphing, the vertex, solving four ways',        day:'', week:'', full:'' },
        { n:10, name:'Radicals and data',             on:'simplifying roots, Pythagoras, scatter plots',   day:'', week:'', full:'' }
      ] },

    { key:'geometry', name:'Geometry', sym:'△', color:'peach', grade:'9th to 11th',
      product:'',            /* one product for the whole course, if you use one */
      fullProduct:'',        /* a SECOND product just for the 15 day full unit packets, if you split them out */
      bundle:'',             /* the whole course in one purchase: '+', a variant id, or a handle */
      bundlePrice:'',        /* only if this course costs a different amount from the rest */
      units:[
        { n:1,  name:'Points, lines, planes, angles', on:'naming, segment and angle addition, pairs',      day:'', week:'', full:'' },
        { n:2,  name:'Reasoning and proof',           on:'conditionals, two column proof, the reasons',    day:'', week:'', full:'' },
        { n:3,  name:'Parallel and perpendicular',    on:'a transversal, the angle pairs, slope',          day:'', week:'', full:'' },
        { n:4,  name:'Congruent triangles',           on:'SSS, SAS, ASA, AAS, HL, CPCTC',                  day:'', week:'', full:'' },
        { n:5,  name:'Relationships in triangles',    on:'midsegments, bisectors, the four centers',       day:'', week:'', full:'' },
        { n:6,  name:'Quadrilaterals',                on:'the family, parallelograms, proving a shape',    day:'', week:'', full:'' },
        { n:7,  name:'Similarity',                    on:'ratios, AA, SSS, SAS, proportional parts',       day:'', week:'', full:'' },
        { n:8,  name:'Right triangles and trig',      on:'Pythagoras, special triangles, SOH CAH TOA',     day:'', week:'', full:'' },
        { n:9,  name:'Circles',                       on:'arcs, chords, tangents, inscribed angles',       day:'', week:'', full:'' },
        { n:10, name:'Area and volume',               on:'polygons, circles, surface area, solids',        day:'', week:'', full:'' }
      ] },

    { key:'algebra2', name:'Algebra 2', sym:'x²', color:'sky', grade:'9th to 11th',
      product:'',            /* one product for the whole course, if you use one */
      fullProduct:'',        /* a SECOND product just for the 15 day full unit packets, if you split them out */
      bundle:'',             /* the whole course in one purchase: '+', a variant id, or a handle */
      bundlePrice:'',        /* only if this course costs a different amount from the rest */
      units:[
        { n:1,  name:'Equations and inequalities',    on:'solving, absolute value, compound',              day:'', week:'', full:'' },
        { n:2,  name:'Linear functions and systems',  on:'graphing, transformations, three variables',     day:'', week:'', full:'' },
        { n:3,  name:'Quadratics and complex numbers', on:'three forms, the four methods, i',              day:'', week:'', full:'' },
        { n:4,  name:'Polynomial functions',          on:'end behaviour, synthetic division, roots',       day:'', week:'', full:'' },
        { n:5,  name:'Radicals and rational exponents', on:'simplifying, solving, extraneous answers',     day:'', week:'', full:'' },
        { n:6,  name:'Rational functions',            on:'simplifying, operations, asymptotes and holes',  day:'', week:'', full:'' },
        { n:7,  name:'Exponentials and logarithms',   on:'graphs, the rules, solving, growth and decay',   day:'', week:'', full:'' },
        { n:8,  name:'Sequences and series',          on:'arithmetic, geometric, sigma notation',          day:'', week:'', full:'' },
        { n:9,  name:'Trigonometry basics',           on:'the unit circle, radians, graphing sine',        day:'', week:'', full:'' },
        { n:10, name:'Statistics and probability',    on:'counting, normal distribution, samples',         day:'', week:'', full:'' }
      ] },

    { key:'precalc', name:'Precalculus', sym:'π', color:'peri', grade:'10th to 12th',
      product:'',            /* one product for the whole course, if you use one */
      fullProduct:'',        /* a SECOND product just for the 15 day full unit packets, if you split them out */
      bundle:'',             /* the whole course in one purchase: '+', a variant id, or a handle */
      bundlePrice:'',        /* only if this course costs a different amount from the rest */
      units:[
        { n:1, name:'Functions and their graphs',     on:'domain, range, parent graphs, transformations',  day:'', week:'', full:'' },
        { n:2, name:'Polynomial and rational functions', on:'roots, end behaviour, asymptotes',            day:'', week:'', full:'' },
        { n:3, name:'Exponentials and logarithms',    on:'graphs, properties, solving, modelling',         day:'', week:'', full:'' },
        { n:4, name:'Trigonometric functions',        on:'the unit circle, radians, graphing all six',     day:'', week:'', full:'' },
        { n:5, name:'Analytic trigonometry',          on:'identities, sum and difference, solving',        day:'', week:'', full:'' },
        { n:6, name:'Laws of sines and cosines',      on:'both laws, area, vectors',                       day:'', week:'', full:'' },
        { n:7, name:'Systems, matrices and conics',   on:'matrix operations, parabolas, ellipses',         day:'', week:'', full:'' },
        { n:8, name:'Sequences, series, probability', on:'sigma, binomial theorem, counting',              day:'', week:'', full:'' },
        { n:9, name:'Limits, an introduction',        on:'from a table, from a graph, continuity',         day:'', week:'', full:'' }
      ] },

    { key:'calculus', name:'Calculus', sym:'∫', color:'lilac', grade:'11th to 12th',
      product:'',            /* one product for the whole course, if you use one */
      fullProduct:'',        /* a SECOND product just for the 15 day full unit packets, if you split them out */
      bundle:'',             /* the whole course in one purchase: '+', a variant id, or a handle */
      bundlePrice:'',        /* only if this course costs a different amount from the rest */
      units:[
        { n:1, name:'Limits and continuity',          on:'from a graph, algebraically, the IVT',           day:'', week:'', full:'' },
        { n:2, name:'The derivative',                 on:'the definition, the tangent line, differentiability', day:'', week:'', full:'' },
        { n:3, name:'Derivative rules',               on:'power, product, quotient, chain, implicit',      day:'', week:'', full:'' },
        { n:4, name:'Applications of the derivative', on:'related rates, extrema, curve sketching, motion', day:'', week:'', full:'' },
        { n:5, name:'Integration',                    on:'antiderivatives, u substitution, Riemann sums',  day:'', week:'', full:'' },
        { n:6, name:'The Fundamental Theorem',        on:'both parts, definite integrals, average value',  day:'', week:'', full:'' },
        { n:7, name:'Applications of integration',    on:'area between curves, volume, accumulation',      day:'', week:'', full:'' },
        { n:8, name:'Differential equations',         on:'separation, slope fields, growth and decay',     day:'', week:'', full:'' }
      ] }

  ]
};